module.exports = __webpack_public_path__ + "img/morph.ffb5ec78.png";